import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-no-access" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "arc-emblem" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/logos/arc-emblem-watermark.svg",
    class: "h-100 w-100"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('pages.noAccess.header')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('pages.noAccess.requestAccess')), 1)
    ]),
    _hoisted_3
  ]))
}